import { useAuth0User } from 'hooks/useAuth0User';
import { isHospitalViewer } from 'utils/helpers/permissions.helpers';

export const useIsHospitalViewer = () => {
  const user = useAuth0User();

  return {
    isHospitalViewer: isHospitalViewer(user),
  };
};
